import { Card, CardContent } from '@/components/ui/card';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from '@/components/ui/carousel';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Star, Quote } from 'lucide-react';
import SectionHeader from '@/components/shared/SectionHeader';

const TestimonialsSection = ({ testimonials = [] }) => {
    if (!testimonials.length) return null;
    return (
        <section className="section-pad" data-testid="home-testimonials-section">
            <div className="container-page">
                <SectionHeader
                    eyebrow="Voices"
                    title="Real stories from those we've served."
                    description="Beneficiaries, volunteers and CSR partners on why VVVSI matters."
                    align="center"
                />
                <div className="mt-10">
                    <Carousel
                        opts={{ align: 'start', loop: true }}
                        className="w-full"
                        data-testid="testimonials-carousel"
                    >
                        <CarouselContent className="-ml-4">
                            {testimonials.map((t) => (
                                <CarouselItem
                                    key={t.id || t.name}
                                    className="pl-4 sm:basis-1/2 lg:basis-1/3"
                                >
                                    <Card className="h-full bg-card border-border shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
                                        <CardContent className="p-6 flex flex-col h-full">
                                            <Quote className="h-6 w-6 text-[hsl(var(--accent))] mb-3" />
                                            <p className="text-[15px] text-foreground/85 leading-relaxed flex-1">
                                                {t.quote}
                                            </p>
                                            <div className="mt-5 flex items-center gap-3">
                                                <Avatar className="h-10 w-10">
                                                    <AvatarImage src={t.photo_url} alt={t.name} />
                                                    <AvatarFallback>
                                                        {t.name.slice(0, 2).toUpperCase()}
                                                    </AvatarFallback>
                                                </Avatar>
                                                <div>
                                                    <div className="font-semibold text-sm text-foreground">
                                                        {t.name}
                                                    </div>
                                                    <div className="text-xs text-muted-foreground">
                                                        {t.role} • {t.location}
                                                    </div>
                                                </div>
                                                <div className="ml-auto flex items-center gap-0.5">
                                                    {Array.from({ length: t.rating || 5 }).map(
                                                        (_, i) => (
                                                            <Star
                                                                key={i}
                                                                className="h-3.5 w-3.5 fill-[hsl(var(--accent))] text-[hsl(var(--accent))]"
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <div className="mt-6 flex items-center justify-center gap-3">
                            <CarouselPrevious className="static translate-y-0" />
                            <CarouselNext className="static translate-y-0" />
                        </div>
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
